/**
 * `/app/widgets/$widgetRef/submissions/$receiptId` — one lead. The page is
 * `pages/forms/SubmissionPage.tsx`.
 *
 * **Every forwarded lead's mail links here** (`forms/service.ts` `submissionUrlOf`), so
 * the address is a promise kept for as long as the mail exists: a receipt the API no
 * longer has is its 404, rendered inside the portal by the route boundary.
 */

import { createFileRoute } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { SubmissionPage } from '../../../../../pages/forms/SubmissionPage.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/submissions/$receiptId')({
  notFoundComponent: NotFound,
  component: SubmissionRoute,
})

function SubmissionRoute() {
  const { widgetRef, receiptId } = Route.useParams()
  return <SubmissionPage widgetRef={widgetRef} receiptId={receiptId} />
}
